import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const [isAuthed, setIsAuthed] = useState(location.state?.user ? true : null);

  useEffect(() => {
    if (location.state?.user) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get("/auth/me");
        if (!cancelled) setIsAuthed(!!res.data?.user_id);
      } catch (e) {
        if (!cancelled) setIsAuthed(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [location.state]);

  if (isAuthed === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
        <div className="text-[#064E3B] font-display text-lg">Checking session…</div>
      </div>
    );
  }
  if (isAuthed === false) return <Navigate to="/login" replace />;
  return children;
}
